import {
  SEND_RATINGS,
  FETCH_RATINGS,
  STORE_RATINGS,
  RESET_RATINGS,
} from './types';

//origin refers to the page where the action is fired.
//could be from treks, lodge or profile

export const sendRatings = (ratings: Object, origin: string, userInfo) => ({
  type: SEND_RATINGS,
  ratings,
  origin,
  userInfo,
});

export const fetchRatings = (origin: string) => ({
  type: FETCH_RATINGS,
  origin,
});

export const storeRatings = (ratings, origin) => ({
  type: STORE_RATINGS,
  origin,
  ratings,
});

export const resetRatings = () => ({
  type: RESET_RATINGS,
});



// WEBPACK FOOTER //
// ./src/redux/actions/ratingsActions.js